// src/hooks/countries/useRestoreCountry.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { restoreCountry } from "../../api/apiCountries";
import parseError from "../../utils/parseError";

const useRestoreCountry = () => {
    const queryClient = useQueryClient();

    const {
        mutate: restore,
        isPending: isRestoring,
    } = useMutation({
        mutationFn: restoreCountry,
        onSuccess: (res) => {
            const message = res?.message || "Country restored successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["countries"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to restore country");
        },
    });

    return {
        restoreCountry: restore,
        isRestore: isRestoring,
    };
};

export default useRestoreCountry;
